export default {

    domain: process.env.NODE_ENV !== 'development' ? 'http://wms.fangjc1986.com:9102/' : 'http://localhost:9102/',
    domainName: '牧行者 WMS 系统',

}